import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Footer from 'components/v2/vn-footer/footer';
import styles from './app-content.less';

const AppContent = props => (
  <div className={classnames(styles.content)}>
    <div className={classnames(styles.page)}>
      {props.children}
      <Footer />
    </div>
  </div>
);

AppContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppContent;
